module.exports = __webpack_public_path__ + "media/icons/ptgray-1862a389.png";